define('utils/dom_ready',[],function(){
  var queue;
  var domIsReady = "readyState" in document  ? /loaded|complete/.test(document.readyState) : !!document.body;

  function flush() {
    if (!queue) {
      return;
    }

    var fn;
    while (fn = queue.shift()) {
      fn();
    }
    queue = null;
  }

  function domReady(fn) {
    if (queue) {
      queue.push(fn);
      return;
    } else {
      fn();
    }
  }

  if(!domIsReady) {
    queue = [];
    if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', flush, false);
      window.addEventListener('load', flush, false);
    } else if (document.attachEvent) {
      document.attachEvent('onreadystatechange', flush);
      window.attachEvent('onload', flush);
    }

    if (document.documentElement.doScroll && window == window.top) {
      var test = function() {
        try {
          document.documentElement.doScroll('left');
        } catch(error) {
          setTimeout(test, 0);
          return;
        }
        flush();
      };
      test();
    }
  }

  return domReady;
});

